import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let QltsReportController = {
    getListReportState: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/report/customer-state`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getListReportResource: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/report/customer-source`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getListReportCampaign: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/report/campaign`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getListReportSale: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/report/list-sale`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getListReportSaleSearch: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/report/search-sale`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getListReportDetailSale: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/report/detail-sale`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
}

export default QltsReportController
